import React from "react";
import ResetPassword from "../components/ResetPassword";

function ResetPasswordConfirm() {
  return (
    <>
      <ResetPassword />
    </>
  );
}

export default ResetPasswordConfirm;
